import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Legal.css';

const Legal = () => {
  return (
    <main className="page-legal">
      <Helmet>
        <title>Mentions Légales | AGKG Créations</title>
        <meta name="description" content="Mentions légales du site agkgcreations.fr. Informations légales, politique de confidentialité, RGPD et cookies." />
        <link rel="canonical" href="https://agkgcreations.fr/mentions-legales" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <section className="page-hero">
        <div className="container">
          <h1 className="section-title">
            Mentions <span>légales</span>
          </h1>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-section">
              <h2>1. Informations légales</h2>
              <p>
                Le site <strong>agkgcreations.fr</strong> est édité par :
              </p>
              <ul>
                <li><strong>Raison sociale :</strong> AGKG Créations</li>
                <li><strong>Adresse :</strong> Agde, Hérault (34), France</li>
                <li><strong>Email :</strong> contact@agkgcreations.fr</li>
                <li><strong>Directeur de la publication :</strong> AGKG Créations</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>2. Hébergement</h2>
              <p>
                Le site est hébergé par un prestataire professionnel assurant la disponibilité
                et la sécurité des données.
              </p>
            </div>

            <div className="legal-section">
              <h2>3. Propriété intellectuelle</h2>
              <p>
                L'ensemble des contenus (textes, images, graphismes, logo, icônes, etc.)
                présents sur le site agkgcreations.fr sont protégés par les lois relatives
                à la propriété intellectuelle. Toute reproduction, représentation, modification
                ou adaptation de tout ou partie du site sans autorisation préalable est interdite.
              </p>
            </div>

            <div className="legal-section">
              <h2>4. Protection des données personnelles (RGPD)</h2>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD),
                vous disposez d'un droit d'accès, de rectification, de suppression et
                d'opposition aux données personnelles vous concernant.
              </p>
              <p>
                Les données collectées via le formulaire de contact (nom, email, téléphone,
                message) sont utilisées uniquement pour répondre à votre demande et ne sont
                jamais transmises à des tiers.
              </p>
              <p>
                Pour exercer vos droits, contactez-nous à :{' '}
                <a href="mailto:contact@agkgcreations.fr">contact@agkgcreations.fr</a>
              </p>
            </div>

            <div className="legal-section">
              <h2>5. Cookies</h2>
              <p>
                Le site peut utiliser des cookies à des fins de mesure d'audience
                (Google Analytics ou équivalent). Ces cookies permettent de collecter des
                informations anonymes sur la fréquentation du site.
              </p>
              <p>
                Vous pouvez à tout moment désactiver les cookies dans les paramètres de
                votre navigateur.
              </p>
            </div>

            <div className="legal-section">
              <h2>6. Limitation de responsabilité</h2>
              <p>
                AGKG Créations s'efforce de fournir des informations exactes et à jour sur
                le site. Toutefois, nous ne pouvons garantir l'exactitude, la complétude ou
                l'actualité des informations diffusées. AGKG Créations ne saurait être tenu
                responsable des dommages directs ou indirects résultant de l'utilisation du site.
              </p>
            </div>

            <div className="legal-section">
              <h2>7. Droit applicable</h2>
              <p>
                Les présentes mentions légales sont régies par le droit français. En cas de
                litige, les tribunaux français seront seuls compétents.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Legal;
